import { Link } from "react-router-dom";
import NewsRow from "@/components/base/NewsRow";
import SectionHeading from "@/components/base/SectionHeading";
import { CATEGORY_LABELS } from "@/types";
import { formatViews, getHot } from "@/utils/media";

export default function HotPicks() {
  const hot = getHot(20);
  const [lead, ...rest] = hot;
  const ranking = hot.slice(0, 6);

  if (!lead) return null;

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="Trending"
        title="热门推荐"
        subtitle="按浏览量与人气综合排序，看看大家都在关注哪些作品。"
        moreTo="/category?sort=hot"
        moreLabel="查看热度榜"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <Link
            to={`/detail/${lead.id}`}
            className="group relative block h-72 w-full overflow-hidden rounded-lg border border-background-200 md:h-80"
          >
            <img
              src={lead.cover}
              alt={`${lead.title} - 羞羞影视资讯`}
              title={lead.title}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6">
              <div className="mb-3 flex items-center gap-2">
                <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-primary-950">
                  热度榜首
                </span>
                <span className="rounded-md bg-background-50/15 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                  {CATEGORY_LABELS[lead.category]} · {lead.region}
                </span>
              </div>
              <h3 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {lead.title}
              </h3>
              <p className="mt-2 line-clamp-2 max-w-2xl text-sm text-background-100/85">
                {lead.summary}
              </p>
              <div className="mt-3 flex items-center gap-4 text-xs text-background-100/80">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-fill text-accent-400" aria-hidden="true" />
                  热度 {formatViews(lead.views)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-400" aria-hidden="true" />
                  评分 {lead.rating.toFixed(1)}
                </span>
              </div>
            </div>
          </Link>

          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {rest.slice(0, 2).map((item) => (
              <Link
                key={item.id}
                to={`/detail/${item.id}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-200"
              >
                <div className="h-20 w-16 shrink-0 overflow-hidden rounded-md bg-background-100">
                  <img
                    src={item.cover}
                    alt={`${item.title} - 羞羞影视资讯`}
                    title={item.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-1 text-xs text-foreground-400">{item.summary}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <aside className="rounded-lg border border-background-200 bg-background-100/60 p-5">
          <div className="mb-4 flex items-center gap-2 border-b border-background-200 pb-4">
            <i className="ri-bar-chart-box-line text-xl text-accent-600" aria-hidden="true" />
            <h3 className="font-heading text-lg font-bold text-foreground-950">人气排行</h3>
          </div>
          <div className="flex flex-col gap-1">
            {ranking.map((item, index) => (
              <NewsRow key={item.id} item={item} index={index} />
            ))}
          </div>
          <Link
            to="/category?sort=hot"
            className="mt-4 flex w-full items-center justify-center gap-1 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            查看完整榜单
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </aside>
      </div>
    </section>
  );
}